import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import Background from '../../common/images/side-bg.jpg';
import loginImg from "../../common/images/login-logo.png";
import QueryContext from '../QueryContext';
import $ from 'jquery';

class MenuSidebar extends Component {
	static contextType = QueryContext;
	constructor(props)
	{
		super(props);
		// const questionId = this.props.params;
		
		this.state = {
			  currentpage:this.props.currentpage,
			  admin_id:localStorage.getItem('admin_id')
		};
		
		// console.log(questionId,'questionId');
    }
	
	activeMenu(currentPage) {
        let status = '';
            if(this.state.currentpage===currentPage) {
                status = 'nav-item has-sub active open'
            }else{
            	status = 'nav-item has-sub enable';
        }
        return status;
    }
	
	componentDidMount() {
		const queryParameters = new URLSearchParams(window.location.search);
		// console.log(queryParameters,'queryParameters');
		this.activeMenutab(this.state.currentpage);
	}
	activeMenutab(page)
	{
		if(page =='user'||page =='companylist'||page =='doctors'||page =='clinic'||page =='traveler')
		{
			$('.ProductsMenu').removeClass('open');
			$('.ApptMenu').removeClass('open');
			$('.AiSettingMenu').removeClass('open');
			$('.SettingMenu').removeClass('open');	
			if($('.userMenu').hasClass('open'))
			{
				$('.userMenu').removeClass('open');
			}else{
				$('.userMenu').addClass('open');
			}
		}else if(page =='AppointmentHistory'||page =='Prescription')
		{
			$('.ProductsMenu').removeClass('open');			
			$('.AiSettingMenu').removeClass('open');
			$('.SettingMenu').removeClass('open');	
			$('.userMenu').removeClass('open');
			if($('.ApptMenu').hasClass('open'))
			{
				$('.ApptMenu').removeClass('open');
			}else{
				$('.ApptMenu').addClass('open');
			}
		}else if(page =='ProductBookingHistory'||page =='ProductCategory'||page =='Product'||page =='Outofstock'||page =='Providerinventory'||page =='requestinventory')
		{
				
			$('.AiSettingMenu').removeClass('open');
			$('.SettingMenu').removeClass('open');	
			$('.userMenu').removeClass('open');
			$('.ApptMenu').removeClass('open');
			if($('.ProductsMenu').hasClass('open'))
			{
				$('.ProductsMenu').removeClass('open');	
			}else{
				$('.ProductsMenu').addClass('open');
			}
		}
		else if(page =='json'||page =='chatquestionai')
		{		
			$('.ProductsMenu').removeClass('open');	
			$('.SettingMenu').removeClass('open');	
			$('.userMenu').removeClass('open');
			$('.ApptMenu').removeClass('open');
			if($('.AiSettingMenu').hasClass('open'))
			{
				$('.AiSettingMenu').removeClass('open');
				
			}else{
				$('.AiSettingMenu').addClass('open');
			}
		}else 
		{	
			$('.ProductsMenu').removeClass('open');	
			$('.AiSettingMenu').removeClass('open');
			$('.userMenu').removeClass('open');
			$('.ApptMenu').removeClass('open');
			if($('.SettingMenu').hasClass('open'))
			{
				$('.SettingMenu').removeClass('open');	
				
			}else{
				$('.SettingMenu').addClass('open');
			}	

			if(page =='Membership' || page == 'MembershipCategory'){
				if($('.MembershipMenu').hasClass('open'))
				{
					$('.MembershipMenu').removeClass('open');
				}else{
					$('.MembershipMenu').addClass('open');
					$('.AdsMenu').removeClass('open');
					$('.GuideMenu').removeClass('open');
				}
			}else if(page =='GuideCategory'||page =='GuideSubCategory'||page =='guide'){
				if($('.GuideMenu').hasClass('open'))
				{
					$('.GuideMenu').removeClass('open');
				}else{
					$('.MembershipMenu').removeClass('open');
					$('.AdsMenu').removeClass('open');
					$('.GuideMenu').addClass('open');
				}
			}else if(page =='advertisementcategory' || page =='advertisement'  ){
				if($('.AdsMenu').hasClass('open'))
				{
					$('.AdsMenu').removeClass('open');
				}else{
					$('.MembershipMenu').removeClass('open');
					$('.AdsMenu').addClass('open');
					$('.GuideMenu').removeClass('open');
				}
			}			
		}
	}
	handleClick = (url) => {
        // Set a value in localStorage for tracking purposes
        // Open the URL in a new tab
        window.open('/dashboard?ehrpanel=true', '_blank', 'noopener,noreferrer');
	}

	userMenu=()=>{
		$('.ProductsMenu').removeClass('open');
		$('.ApptMenu').removeClass('open');
		$('.AiSettingMenu').removeClass('open');
		$('.SettingMenu').removeClass('open');	
		if($('.userMenu').hasClass('open'))
		{
			$('.userMenu').removeClass('open');
		}else{
			$('.userMenu').addClass('open');
		}
	}
	ApptMenu=()=>{
		$('.userMenu').removeClass('open');
		$('.ProductsMenu').removeClass('open');
		$('.AiSettingMenu').removeClass('open');
		$('.SettingMenu').removeClass('open');	
		if($('.ApptMenu').hasClass('open'))
		{
			$('.ApptMenu').removeClass('open');
		}else{
			$('.ApptMenu').addClass('open');
		}
	}
	SettingMenu=()=>{		
		$('.userMenu').removeClass('open');
		$('.ProductsMenu').removeClass('open');
		$('.ApptMenu').removeClass('open');
		$('.AiSettingMenu').removeClass('open');
		if($('.SettingMenu').hasClass('open'))
		{
			$('.SettingMenu').removeClass('open');
		}else{
			$('.SettingMenu').addClass('open');
		}
	}
	AiSettingMenu=()=>{
		$('.userMenu').removeClass('open');
		$('.ProductsMenu').removeClass('open');
		$('.ApptMenu').removeClass('open');
		$('.SettingMenu').removeClass('open');	
		if($('.AiSettingMenu').hasClass('open'))
		{
			$('.AiSettingMenu').removeClass('open');
		}else{
			$('.AiSettingMenu').addClass('open');
		}
	}
	ProductsMenu=()=>{
		$('.userMenu').removeClass('open');
		$('.ApptMenu').removeClass('open');
		$('.AiSettingMenu').removeClass('open');
		$('.SettingMenu').removeClass('open');	


		if($('.ProductsMenu').hasClass('open'))
		{
			$('.ProductsMenu').removeClass('open');
		}else{
			$('.ProductsMenu').addClass('open');
		}
	}

	

	MembershipMenu =()=>{		
		// $('.userMenu').removeClass('open');
		// $('.ProductsMenu').removeClass('open');
		// $('.ApptMenu').removeClass('open');
		// $('.AiSettingMenu').removeClass('open');
		if($('.MembershipMenu').hasClass('open'))
		{
			$('.MembershipMenu').removeClass('open');
		}else{
			$('.MembershipMenu').addClass('open');
			$('.AdsMenu').removeClass('open');
			$('.GuideMenu').removeClass('open');

		}
	}

	GuideMenu =()=>{		
		// $('.userMenu').removeClass('open');
		// $('.ProductsMenu').removeClass('open');
		// $('.ApptMenu').removeClass('open');
		// $('.AiSettingMenu').removeClass('open');
		if($('.GuideMenu').hasClass('open'))
		{
			$('.GuideMenu').removeClass('open');
		}else{
			$('.GuideMenu').addClass('open');
			$('.AdsMenu').removeClass('open');
			$('.MembershipMenu').removeClass('open');

		}
	}

	AdsMenu =()=>{		
		
		if($('.AdsMenu').hasClass('open'))
		{
			$('.AdsMenu').removeClass('open');
		}else{
			$('.AdsMenu').addClass('open');
			$('.MembershipMenu').removeClass('open');
			$('.GuideMenu').removeClass('open');
		}
	}
  render() {
	// console.log(this.state.currentpage,'currentpage');
	const {ehrpanel}  = this.context;
    return (	
	<div className="sidebar-menu mobi-close">
	   {(ehrpanel)?<div className="main-menu menu-fixed menu-dark menu-accordion menu-shadow expanded" data-scroll-to-active="true" >
		<div className="navbar-header expanded">
		<ul className="nav navbar-nav flex-row position-relative">
		<li className="nav-item mr-auto">
		<a className="navbar-brand" href="#">
		{/* <img src={loginImg} /> */}
		<h3 className="brand-text">EMR</h3>
		</a>
		</li>
		<li className="nav-item d-md-none"><a href="javascript:void(0)" className="nav-link close-navbar mb-side-nav"><i className="ft-x"></i></a></li>
		</ul>
		</div>
		<div className="navigation-background" style={{background: `url(${Background})`}}></div>
		<div className="main-menu-content ps ps--active-y" style={{height: "587px;"}}>
		<Scrollbars className="custom-scroll-wrap">
		<ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
		<li className={this.activeMenu('dashboard')}>
		<a href="/dashboard?ehrpanel=true">
		<i className="ft-home"></i>
		<span className="menu-title" data-i18n="">Dashboard</span>
		</a>
		</li>

		<li className={this.activeMenu('user')}>
		<a href="/user?ehrpanel=true">
		<i className="ft-users"></i>
		<span className="menu-title" data-i18n="">Pet Parents</span>
		</a>
		</li>

		<li className={this.activeMenu('clinic')}>
		<a href="/clinic?ehrpanel=true">
		{/* <i className="ft-users-vets"></i> */}
		<svg xmlns="http://www.w3.org/2000/svg" fill="#ffffff" version="1.1" viewBox="6.58 10.78 86.83 82">  <path d="m8.1406 92.781h83.703c0.85938 0 1.5625-0.70312 1.5625-1.5625s-0.70312-1.5625-1.5625-1.5625h-9.2031v-40.953l-32.656-25.906-32.672 25.922v40.938h-9.1719c-0.875 0-1.5625 0.70312-1.5625 1.5625s0.6875 1.5625 1.5625 1.5625zm24.641-37.047c0-0.875 0.70312-1.5625 1.5625-1.5625h8.3594v-8.375c0-0.85938 0.70312-1.5625 1.5625-1.5625h11.469c0.85938 0 1.5625 0.70312 1.5625 1.5625v8.375h8.3594c0.85938 0 1.5625 0.6875 1.5625 1.5625v11.453c0 0.85938-0.70312 1.5625-1.5625 1.5625h-8.3594v8.3594c0 0.85938-0.70312 1.5625-1.5625 1.5625h-11.469c-0.85938 0-1.5625-0.70312-1.5625-1.5625v-8.3594h-8.3594c-0.85938 0-1.5625-0.70312-1.5625-1.5625z"></path>  <path d="m45.828 67.188v8.3594h8.3438v-8.3594c0-0.875 0.6875-1.5625 1.5625-1.5625h8.3594v-8.3281h-8.3594c-0.875 0-1.5625-0.70312-1.5625-1.5625v-8.375h-8.3438v8.375c0 0.85938-0.6875 1.5625-1.5625 1.5625h-8.3594v8.3281h8.3594c0.875 0 1.5625 0.6875 1.5625 1.5625z"></path>  <path d="m14.641 46.859 0.23438-0.1875 34.141-27.094c0.28125-0.23438 0.625-0.34375 0.96875-0.34375s0.6875 0.10938 0.96875 0.34375l34.125 27.078 0.23438 0.1875 3.8906 3.0781 3.9062-4.9219-43.125-34.219-43.125 34.219 3.9062 4.9219z"></path> </svg>
		<span className="menu-title" data-i18n="">Clinic</span>
		</a>
		</li>

		<li className={this.activeMenu('doctors')}>
		<a href="/doctors?ehrpanel=true">
		{/* <i className="ft-users-vets"></i> */}
		<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="9.8 6.25 80.4 87.51" fill="#ffffff">  <path d="m70.062 51.391v9c4.6953 0.75391 8.2969 4.8242 8.2969 9.7266v10.223c0 3.2461-2.6406 5.8867-5.8867 5.8867-0.86328 0-1.5625-0.69922-1.5625-1.5625 0-0.86328 0.69922-1.5625 1.5625-1.5625 1.5234 0 2.7617-1.2383 2.7617-2.7617v-10.223c0-3.7148-3.0234-6.7383-6.7383-6.7383s-6.7383 3.0234-6.7383 6.7383v10.223c0 1.5234 1.2383 2.7617 2.7617 2.7617 0.86328 0 1.5625 0.69922 1.5625 1.5625 0 0.86328-0.69922 1.5625-1.5625 1.5625-3.2461 0-5.8867-2.6406-5.8867-5.8867v-10.223c0-4.9102 3.6094-8.9805 8.3086-9.7305v-10.375c-4.0508-1.5664-8.4453-2.4336-13.047-2.4336h-7.7852c-4.6094 0-9.0156 0.87109-13.078 2.4453v20.211c3.7031 0.73047 6.5078 4 6.5078 7.9141 0 4.4531-3.6211 8.0742-8.0742 8.0742s-8.0742-3.6211-8.0742-8.0742c0-3.918 2.8086-7.1875 6.5156-7.9141v-18.828c-11.91 5.9648-20.109 18.281-20.109 32.48v9.8633h80.402v-9.8633c0-14.211-8.2148-26.539-20.141-32.496z"></path>  <path d="m50 44.449c10.531 0 19.102-8.5664 19.102-19.102 0-10.531-8.5703-19.102-19.102-19.102s-19.102 8.5703-19.102 19.102 8.5703 19.102 19.102 19.102z"></path>  <path d="m26.516 78.152c0 2.7305 2.2188 4.9492 4.9492 4.9492 2.7266 0 4.9492-2.2188 4.9492-4.9492 0-2.7266-2.2188-4.9492-4.9492-4.9492-2.7266 0-4.9492 2.2188-4.9492 4.9492z"></path> </svg>
		<span className="menu-title" data-i18n="">Vets</span>
		</a>
		</li>

		<li className={this.activeMenu('technicians')}>
		<a href="/technicians?ehrpanel=true">
		<svg  version="1.1" x="0px" y="0px" viewBox="0.53 0.94 11.64 10.82" fill="#FFFFFF"><g transform="translate(0,-284.29999)"><g transform="matrix(1.3389542,0,0,1.3389542,4552.1998,-586.20481)" ><path transform="matrix(0.26458333,0,0,0.26458333,0,284.29998)" d="m -12825.379,1398.7324 a 6.9005371,6.9005371 0 0 0 -1.209,4.1758 0.89741802,0.89741802 0 0 0 0.162,0.4805 1.4110538,1.4110538 0 0 1 0.04,1.5937 6.8206405,6.8206405 0 0 0 -1.148,3.7832 h 0.02 a 3.2989036,3.2989036 0 0 0 2.125,3.3614 1.5121651,1.5121651 0 0 0 1.352,0.8359 h 1.271 a 3.9010375,3.9010375 0 0 1 -0.04,-0.5156 2.5480932,2.5480932 0 0 1 -0.09,0.01 0.90540045,0.90540045 0 0 1 -0.928,-0.7051 1.3630832,1.3630832 0 0 1 -0.04,-0.4785 0.3712479,0.3712479 0 0 1 0.736,0.098 0.62137357,0.62137357 0 0 0 0,0.2168 0.16369081,0.16369081 0 0 0 0.166,0.127 1.8063835,1.8063835 0 0 0 1.191,-0.5274 0.44721853,0.44721853 0 0 1 0.633,0 1.8063835,1.8063835 0 0 0 1.194,0.5274 0.16369081,0.16369081 0 0 0 0.166,-0.127 0.62137357,0.62137357 0 0 0 0,-0.2168 0.3712479,0.3712479 0 0 1 0.736,-0.098 1.3630832,1.3630832 0 0 1 -0.04,0.4785 0.90540045,0.90540045 0 0 1 -0.926,0.7051 2.5480932,2.5480932 0 0 1 -0.1,-0.01 3.9010375,3.9010375 0 0 1 0,0.5156 h 1.27 a 1.5121651,1.5121651 0 0 0 1.352,-0.8359 3.2989036,3.2989036 0 0 0 2.123,-3.3614 6.8206405,6.8206405 0 0 0 -1.149,-3.7832 1.4110538,1.4110538 0 0 1 0.04,-1.5937 0.89741802,0.89741802 0 0 0 0.162,-0.4805 6.9005371,6.9005371 0 0 0 -1.209,-4.1758 7.0488639,7.0488639 0 0 0 -2.076,4.0703 0.44721853,0.44721853 0 0 1 -0.596,0.3555 3.6713038,3.6713038 0 0 0 -2.521,0 0.44721853,0.44721853 0 0 1 -0.596,-0.3555 7.0488639,7.0488639 0 0 0 -2.076,-4.0703 z m 1.799,7.4864 a 0.48079785,0.48079785 0 0 1 0.488,0.4882 0.4815,0.4815 0 0 1 -0.963,0 0.48079785,0.48079785 0 0 1 0.475,-0.4882 z m 4.334,0.01 a 0.48094487,0.48094487 0 0 1 0.496,0.4804 0.4815,0.4815 0 1 1 -0.963,0 0.48094487,0.48094487 0 0 1 0.467,-0.4804 z m -2.172,2.8437 a 0.86770737,0.86770737 0 0 1 0.563,0.1934 0.57428699,0.57428699 0 0 1 0,0.8925 0.86770737,0.86770737 0 0 1 -1.094,0 0.57428699,0.57428699 0 0 1 0,-0.8925 0.86770737,0.86770737 0 0 1 0.531,-0.1934 z"  fill="#FFFFFF" stroke="none"/><path transform="matrix(0.26458333,0,0,0.26458333,0,284.29998)" d="m -12842.299,1404.543 a 6.1191046,6.1191046 0 0 0 -5.908,6.1152 v 4.6758 a 0.55628236,0.55628236 0 0 0 0.557,0.5566 h 11.896 v -7.1738 a 4.0794032,4.0794032 0 0 1 -0.305,-0.039 v 0 a 7.1935238,7.1935238 0 0 1 -5.358,-4.1211 3.1881106,3.1881106 0 0 1 -0.268,-0.01 6.1191046,6.1191046 0 0 0 -0.611,-0.01 z m -1.896,7.6699 h 4.203 v 0.7422 h -4.203 z"  fill="#FFFFFF" stroke="none"/><path transform="matrix(0.26458333,0,0,0.26458333,0,284.29998)" d="m -12835.143,1385.3496 a 8.7588129,8.7588129 0 0 0 -5.386,1.666 1.4834193,1.4834193 0 0 0 -0.614,1.1992 v 3.7735 h 11.516 v -3.7735 a 1.4834193,1.4834193 0 0 0 -0.613,-1.1992 8.7588129,8.7588129 0 0 0 -4.903,-1.666 z m -0.611,1.4746 h 0.74 v 1.3848 h 1.385 v 0.7422 h -1.385 v 1.3847 h -0.74 v -1.3847 h -1.387 v -0.7422 h 1.387 z"  fill="#FFFFFF" stroke="none"/><path d="m -3392.3293,657.8638 a 0.67418298,0.67418298 0 0 0 0.1648,0.0975 0.83590553,0.83590553 0 0 1 -0.095,0.4852 0.07866734,0.07866734 0 0 1 -0.1389,0 0.83590553,0.83590553 0 0 1 -0.095,-0.4852 0.67418298,0.67418298 0 0 0 0.1649,-0.0975 z"  fill="#FFFFFF" stroke="none"/><path d="m -3393.5197,658.08132 a 0.59633771,0.59633771 0 0 0 0.4933,0.26115 h 0.3907 v 0.43156 a 0.14718304,0.14718304 0 0 1 -0.1473,0.14718 h -3.1478 v -1.89787 a 1.0793421,1.0793421 0 0 0 0.081,-0.0104 1.9032865,1.9032865 0 0 0 1.4175,-1.08998 0.84352094,0.84352094 0 0 0 0.071,-0.002 1.6190131,1.6190131 0 0 1 0.5251,0.0517 2.0008718,2.0008718 0 0 0 -0.3064,1.05488 1.0690789,1.0690789 0 0 0 0.6224,1.05346 z"  fill="#FFFFFF" stroke="none"/><path d="m -3395.8828,656.81935 a 0.88309806,0.88309806 0 0 1 -0.2927,0 1.7070425,1.7070425 0 0 1 -1.2462,-0.92537 0.84352094,0.84352094 0 0 0 0.5472,-0.46317 1.7591064,1.7591064 0 0 0 1.6914,0 0.84352094,0.84352094 0 0 0 0.5471,0.46317 1.7070425,1.7070425 0 0 1 -1.2468,0.92537 z"  fill="#FFFFFF" stroke="none"/><path d="m -3394.4802,654.10026 a 4.552076,4.552076 0 0 0 -0.011,-1.3073 h -3.0758 a 4.552076,4.552076 0 0 0 -0.01,1.3073 1.5628624,1.5628624 0 0 0 3.0972,0 z" /></g></g></svg>
		{/* <i className="ft-users-vets"></i> */}
		<span className="menu-title" data-i18n="">Technicians</span>
		</a>
		</li>

		<li className={this.activeMenu('FutureAppointmentHistory')}>
		<a href="/future-appointment-history?ehrpanel=true">
			<i className="ft-fut-appt" aria-hidden="true"></i>
			<span className="menu-title" data-i18n="">Future Appointments</span>
		</a>
		</li>

		<li className={this.activeMenu('OngoingAppointmentHistory')}>
		<a href="/ongoing-appointment-history?ehrpanel=true">
			<i className="ft-ongo-appt" aria-hidden="true"></i>
			<span className="menu-title" data-i18n="">Ongoing Appointments</span>
		</a>
		</li>
		<li className={this.activeMenu('PastAppointmentHistory')}>
		<a href="/past-appointment-history?ehrpanel=true">
			<i className="ft-past-appt" aria-hidden="true"></i>
			<span className="menu-title" data-i18n="">Past Appointments</span>
		</a>
		</li>

		<li className={this.activeMenu('setting')}>
		<a href="/setting" title="Back to Dashboard">
		<i className="ft-settings"></i>
		<span className="menu-title" data-i18n="">Back to Dashboard</span>
		</a>
		</li>


		{/* <li className={this.activeMenu('user')}>
		<a href="/user?ehrpanel=true">
		<i className="ft-users"></i>
		<span className="menu-title" data-i18n="">Pet Parent</span>
		</a>
		</li>

		<li className={this.activeMenu('doctors')}>
		<a href="/doctors?ehrpanel=true">
		<i className="ft-users"></i>
		<span className="menu-title" data-i18n="">Providers</span>
		</a>
		</li>


		<li className={this.activeMenu('AppointmentHistory')}>
		<a href="/appointment-history?ehrpanel=true">
			<i className="ft-server" aria-hidden="true"></i>
			<span className="menu-title" data-i18n="">Appointments</span>
		</a>
		</li> */}


		</ul>
		</Scrollbars>
		</div>
		</div>	
		:<div className="main-menu menu-fixed menu-dark menu-accordion menu-shadow expanded" data-scroll-to-active="true" >
  <div className="navbar-header expanded">
    <ul className="nav navbar-nav flex-row position-relative">
      <li className="nav-item mr-auto">
        <a className="navbar-brand" href="#">
        {/* <img src={loginImg} /> */}
          <h3 className="brand-text">Admin</h3>
        </a>
      </li>
      <li className="nav-item d-md-none"><a href="javascript:void(0)" className="nav-link close-navbar mb-side-nav"><i className="ft-x"></i></a></li>
    </ul>
  </div>
  <div className="navigation-background" style={{background: `url(${Background})`}}></div>
  <div className="main-menu-content ps ps--active-y" style={{height: "587px;"}}>
  <Scrollbars className="custom-scroll-wrap">
    <ul className="navigation navigation-main" id="main-menu-navigation" data-menu="menu-navigation">
      <li className={this.activeMenu('dashboard')}>
        <a href="/dashboard">
          <i>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256a256 256 0 1 1 512 0 256 256 0 1 1 -512 0zm320 96c0-26.9-16.5-49.9-40-59.3L280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 172.7c-23.5 9.5-40 32.5-40 59.3 0 35.3 28.7 64 64 64s64-28.7 64-64zM144 176a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm-16 80a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm288 32a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM400 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"></path></svg>
		  </i>
          <span className="menu-title" data-i18n="">Dashboard</span>
        </a>
      </li>

	  

	  <li className={this.activeMenu('EMR')}>
		<a href="javascript://" onClick={this.handleClick.bind(this)} target='_blank'>
		<i className="ft-emr-panel"></i>
		<span className="menu-title" data-i18n="">EMR Panel</span>
		</a>
		</li>

		<li className='Sidemenu-submenu userMenu ' onClick={this.userMenu.bind(this)}>
        <a href="#" >
          <i className="ft-users"></i>
          <span className="menu-title" data-i18n="">User Management</span>
        </a>
		<svg  class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>
		<ul class="submenu">
			{/* <li class="nav-item has-sub enable"><a href="/dashboard"><i class="ft-home"></i><span class="menu-title" data-i18n="">Dashboard</span></a></li> */}			
			{this.state.admin_id == 1 ?<li className={this.activeMenu('companylist')+' nav-item has-sub enable'}>
					<a title="Company" href="/company">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zM176 352l32 0c17.7 0 32 14.3 32 32l0 80-96 0 0-80c0-17.7 14.3-32 32-32zM96 112c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zM240 96l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16zM96 240c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32zm144-16l32 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16z"></path></svg>
						</i>
						<span>Companies</span>
					</a>
		        </li>:''}  

				<li className={this.activeMenu('user')+' nav-item has-sub enable'}>
					<a href="/user">
					<i className="ft-users"></i>
					<span className="menu-title" data-i18n="">Users</span>
					</a>
				</li>

				<li className={this.activeMenu('doctors')+' nav-item has-sub enable'}>
					<a href="/doctors">
					<i><svg xmlns="http://www.w3.org/2000/svg" viewBox="0.1 32.05 511.85 447.95"><path d="M234.5 92.9c14.3 42.9-.3 86.2-32.6 96.8s-70.1-15.6-84.4-58.5 .3-86.2 32.6-96.8 70.1 15.6 84.4 58.5zM100.4 198.6c18.9 32.4 14.3 70.1-10.2 84.1s-59.7-.9-78.5-33.3-14.3-70.1 10.2-84.1 59.7 .9 78.5 33.3zM69.2 401.2C121.6 259.9 214.7 224 256 224s134.4 35.9 186.8 177.2c3.6 9.7 5.2 20.1 5.2 30.5l0 1.6c0 25.8-20.9 46.7-46.7 46.7-11.5 0-22.9-1.4-34-4.2l-88-22c-15.3-3.8-31.3-3.8-46.6 0l-88 22c-11.1 2.8-22.5 4.2-34 4.2-25.8 0-46.7-20.9-46.7-46.7l0-1.6c0-10.4 1.6-20.8 5.2-30.5zM421.8 282.7c-24.5-14-29.1-51.7-10.2-84.1s54-47.3 78.5-33.3 29.1 51.7 10.2 84.1-54 47.3-78.5 33.3zM310.1 189.7c-32.3-10.6-46.9-53.9-32.6-96.8s52.1-69.1 84.4-58.5 46.9 53.9 32.6 96.8-52.1 69.1-84.4 58.5z"></path></svg></i>
					<span className="menu-title" data-i18n="">Vets</span>
					</a>
				</li>
				<li className={this.activeMenu('technicians')+' nav-item has-sub enable'}>
					<a href="/technicians">
					<i>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="24.02 0 519.98 519.97"><path d="M509.4 98.6c7.6-7.6 20.3-5.7 24.1 4.3 6.8 17.7 10.5 37 10.5 57.1 0 88.4-71.6 160-160 160-17.5 0-34.4-2.8-50.2-8L146.9 498.9c-28.1 28.1-73.7 28.1-101.8 0s-28.1-73.7 0-101.8L232 210.2c-5.2-15.8-8-32.6-8-50.2 0-88.4 71.6-160 160-160 20.1 0 39.4 3.7 57.1 10.5 10 3.8 11.8 16.5 4.3 24.1l-88.7 88.7c-3 3-4.7 7.1-4.7 11.3l0 41.4c0 8.8 7.2 16 16 16l41.4 0c4.2 0 8.3-1.7 11.3-4.7l88.7-88.7z"></path></svg>
					</i>
					<span className="menu-title" data-i18n="">Technicians</span>
					</a>
				</li>

				<li className={this.activeMenu('clinic')+' nav-item has-sub enable'}>
					<a href="/clinic">		
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M480 0c17.7 0 32 14.3 32 32l96 0c17.7 0 32 14.3 32 32l0 96c0 17.7-14.3 32-32 32l-96 0 0 288c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-448c0-17.7 14.3-32 32-32zM267.5 59.1L400 186.9 400 503.4c-9.4 5.4-20.3 8.6-32 8.6l-256 0c-35.3 0-64-28.7-64-64l0-144-19.9 0C12.6 304 0 291.4 0 275.9 0 268.3 3.1 261 8.6 255.7L212.5 59.1C219.9 52 229.7 48 240 48s20.1 4 27.5 11.1zM204.8 256.8l0 44-44 0c-9.7 0-17.6 7.9-17.6 17.6l0 35.2c0 9.7 7.9 17.6 17.6 17.6l44 0 0 44c0 9.7 7.9 17.6 17.6 17.6l35.2 0c9.7 0 17.6-7.9 17.6-17.6l0-44 44 0c9.7 0 17.6-7.9 17.6-17.6l0-35.2c0-9.7-7.9-17.6-17.6-17.6l-44 0 0-44c0-9.7-7.9-17.6-17.6-17.6l-35.2 0c-9.7 0-17.6 7.9-17.6 17.6z"></path></svg>
					<span className="menu-title" data-i18n="">Clinic</span>
					</a>
					</li>

					<li className={this.activeMenu('referaluserlist')+' nav-item has-sub enable'}>
					<a href="/referaluserlist">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="48 8 592 504"><path d="M136 128a120 120 0 1 1 240 0 120 120 0 1 1 -240 0zM48 482.3C48 383.8 127.8 304 226.3 304l59.4 0c98.5 0 178.3 79.8 178.3 178.3 0 16.4-13.3 29.7-29.7 29.7L77.7 512C61.3 512 48 498.7 48 482.3zM544 96c13.3 0 24 10.7 24 24l0 48 48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0 0 48c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-48-48 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0 0-48c0-13.3 10.7-24 24-24z"></path></svg>
						</i>
						<span className="menu-title" data-i18n="">Invited Users</span>
					</a>
				</li>
       			 <li className={this.activeMenu('InviteDiscount')+' nav-item has-sub enable'}>
					<a href="/InviteDiscount">
						<i className="ft-discount" aria-hidden="true"></i>
						<span className="menu-title" data-i18n="">Manage Invite Discounts</span>
					</a>
				</li>

		</ul>
      </li>
		
		<li className='Sidemenu-submenu ApptMenu '>
			<a href="#" onClick={this.ApptMenu.bind(this)}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 480"><path d="M320 0c17.7 0 32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32zm22 161.7c-10.7-7.8-25.7-5.4-33.5 5.3L189.1 331.2 137 279.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.9 7.5 18.8 7s13.4-4.1 17.5-9.8L347.3 195.2c7.8-10.7 5.4-25.7-5.3-33.5z"></path></svg>
			</i>
			<span className="menu-title" data-i18n="">Appointments</span>
			</a>
			<svg class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>
			<ul class="submenu">
					<li className={this.activeMenu('AppointmentHistory')+' nav-item has-sub enable'}>
						<a href="/appointment-history">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 480"><path d="M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zM64 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Appointment History</span>
						</a>
					</li>
					<li className={this.activeMenu('Prescription')+' nav-item has-sub enable'}>
						<a href="/prescription">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0.02 384 511.97"><path d="M14 2.2C22.5-1.7 32.5-.3 39.6 5.8L80 40.4 120.4 5.8c9-7.7 22.3-7.7 31.2 0L192 40.4 232.4 5.8c9-7.7 22.2-7.7 31.2 0L304 40.4 344.4 5.8c7.1-6.1 17.1-7.5 25.6-3.6S384 14.6 384 24l0 464c0 9.4-5.5 17.9-14 21.8s-18.5 2.5-25.6-3.6l-40.4-34.6-40.4 34.6c-9 7.7-22.2 7.7-31.2 0l-40.4-34.6-40.4 34.6c-9 7.7-22.3 7.7-31.2 0L80 471.6 39.6 506.2c-7.1 6.1-17.1 7.5-25.6 3.6S0 497.4 0 488L0 24C0 14.6 5.5 6.1 14 2.2zM104 136c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0zM80 352c0 13.3 10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0c-13.3 0-24 10.7-24 24zm24-120c-13.3 0-24 10.7-24 24s10.7 24 24 24l176 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-176 0z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Prescription Management</span>
						</a>
					</li>		
					

			</ul>
		</li>
		<li className='Sidemenu-submenu ProductsMenu '>
			<a href="#" onClick={this.ProductsMenu.bind(this)}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 112c0-26.5 21.5-48 48-48s48 21.5 48 48l0 112-96 0 0-112zM176 368c0-48.7 18.1-93.2 48-127l0-129C224 50.1 173.9 0 112 0S0 50.1 0 112L0 400c0 61.9 50.1 112 112 112 37.3 0 70.3-18.2 90.7-46.3-17-28.6-26.7-62-26.7-97.7zm64.7 67.4c4.6 8.7 16.3 9.7 23.3 2.7L438.1 264c7-7 6-18.7-2.7-23.3-20.1-10.7-43-16.7-67.4-16.7-79.5 0-144 64.5-144 144 0 24.3 6 47.3 16.7 67.4zM297.9 472c-7 7-6 18.7 2.7 23.3 20.1 10.7 43 16.7 67.4 16.7 79.5 0 144-64.5 144-144 0-24.3-6-47.3-16.7-67.4-4.6-8.7-16.3-9.7-23.3-2.7L297.9 472z"/></svg>
			</i>
			<span className="menu-title" data-i18n="">Products</span>
			</a>
			<svg class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>
			<ul class="submenu">					
					<li className={this.activeMenu('ProductBookingHistory')+' nav-item has-sub enable'}>
						<a href="/product-booking-history">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M64 96c0-35.3 28.7-64 64-64l384 0c35.3 0 64 28.7 64 64l0 240-64 0 0-240-384 0 0 240-64 0 0-240zM0 403.2C0 392.6 8.6 384 19.2 384l601.6 0c10.6 0 19.2 8.6 19.2 19.2 0 42.4-34.4 76.8-76.8 76.8L76.8 480C34.4 480 0 445.6 0 403.2zM288 160c0-8.8 7.2-16 16-16l32 0c8.8 0 16 7.2 16 16l0 40 40 0c8.8 0 16 7.2 16 16l0 32c0 8.8-7.2 16-16 16l-40 0 0 40c0 8.8-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-40-40 0c-8.8 0-16-7.2-16-16l0-32c0-8.8 7.2-16 16-16l40 0 0-40z"/></svg>
							</i>
							<span className="menu-title" data-i18n="">Product Order History</span>
						</a>
					</li>
					
		
					<li className={this.activeMenu('ProductCategory')+' nav-item has-sub enable'}>
						<a href="/ProductCategory">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 480"><path d="M192 56l0 40 128 0 0-40c0-4.4-3.6-8-8-8L200 48c-4.4 0-8 3.6-8 8zm-48 8l0-8c0-30.9 25.1-56 56-56L312 0c30.9 0 56 25.1 56 56l0 424-224 0 0-416zM96 176l0 304-32 0c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l32 0 0 80zM416 480l0-384 32 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64l-32 0zM244 208c-8.8 0-16 7.2-16 16l0 36-36 0c-8.8 0-16 7.2-16 16l0 24c0 8.8 7.2 16 16 16l36 0 0 36c0 8.8 7.2 16 16 16l24 0c8.8 0 16-7.2 16-16l0-36 36 0c8.8 0 16-7.2 16-16l0-24c0-8.8-7.2-16-16-16l-36 0 0-36c0-8.8-7.2-16-16-16l-24 0z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Product Category</span>
						</a>
					</li>
					<li className={this.activeMenu('Product')+' nav-item has-sub enable'}>
						<a href="/product">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="5.68 0 506.32 512"><path d="M495.3 76.6c-4.6-8.7-16.3-9.7-23.3-2.7L297.9 248c-7 7-6 18.7 2.7 23.3 20.1 10.7 43 16.7 67.4 16.7 79.5 0 144-64.5 144-144 0-24.3-6-47.3-16.7-67.4zM240.7 211.4c4.6 8.7 16.3 9.7 23.3 2.7L438.1 40c7-7 6-18.7-2.7-23.3-20.1-10.7-43-16.7-67.4-16.7-79.5 0-144 64.5-144 144 0 24.3 6 47.3 16.7 67.4zM144 224C79.2 224 24.4 266.8 6.3 325.6 3.4 335.1 11 344 20.9 344l246.2 0c9.9 0 17.5-8.9 14.6-18.4-.9-3-1.9-5.9-3-8.7-37.4-18.1-68-48-87-84.8-14.9-5.2-30.9-8.1-47.6-8.1zM281.7 410.4c2.9-9.5-4.7-18.4-14.6-18.4L20.9 392C11 392 3.4 400.9 6.3 410.4 24.4 469.2 79.2 512 144 512s119.6-42.8 137.7-101.6z"></path></svg>
							</i>
							<span className="menu-products" data-i18n="">Products</span>
						</a>
					</li>
					<li className={this.activeMenu('Providerinventory')+' nav-item has-sub enable'}>
						<a href="/providerinventory">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M0 32C0 14.3 14.3 0 32 0L352 0c17.7 0 32 14.3 32 32l0 32c0 17.7-14.3 32-32 32L32 96C14.3 96 0 81.7 0 64L0 32zM32 144l320 0 0 304c0 35.3-28.7 64-64 64L96 512c-35.3 0-64-28.7-64-64l72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-48 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-48 72 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-72 0 0-64z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Vets Products</span>
						</a>
					</li>
					<li className={this.activeMenu('requestinventory')+' nav-item has-sub enable'}>
						<a href="/requestinventory">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M288 0L128 0C110.3 0 96 14.3 96 32s14.3 32 32 32L128 215.5 7.5 426.3C2.6 435 0 444.7 0 454.7 0 486.4 25.6 512 57.3 512l333.4 0c31.6 0 57.3-25.6 57.3-57.3 0-10-2.6-19.8-7.5-28.4L320 215.5 320 64c17.7 0 32-14.3 32-32S337.7 0 320 0L288 0zM192 215.5l0-151.5 64 0 0 151.5c0 11.1 2.9 22.1 8.4 31.8l41.6 72.7-164 0 41.6-72.7c5.5-9.7 8.4-20.6 8.4-31.8z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Refill Vets Products</span>
						</a>
					</li>
					

			</ul>
		</li>
		<li className='Sidemenu-submenu AiSettingMenu '>
			<a href="#" onClick={this.AiSettingMenu.bind(this)}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -32 640 512"><path d="M352 0c0-17.7-14.3-32-32-32S288-17.7 288 0l0 64-96 0c-53 0-96 43-96 96l0 224c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-224c0-53-43-96-96-96l-96 0 0-64zM160 368c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm120 0c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zm120 0c0-13.3 10.7-24 24-24l32 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24zM224 176a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm144 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM64 224c0-17.7-14.3-32-32-32S0 206.3 0 224l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96zm544-32c-17.7 0-32 14.3-32 32l0 96c0 17.7 14.3 32 32 32s32-14.3 32-32l0-96c0-17.7-14.3-32-32-32z"></path></svg>
			</i>
			<span className="menu-title" data-i18n="">AI Settings</span>
			</a>
			<svg class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>
			<ul class="submenu">
					
					{/* <li className={this.activeMenu('json')+' nav-item has-sub enable'}>
						<a href="/json">
							<i className="ft-edit" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">Instant Chat Agent (AI)</span>
						</a>
					</li> */}
					
			<li className={this.activeMenu('json')+' nav-item has-sub enable'}>
				<a href="/json">
				{/* <i className='d-flex justify-content-center align-items-center'> */}
				<svg className='end-0' style={{height:"32px !imprtant",width:"32px !imprtant"}} xmlns="http://www.w3.org/2000/svg" version="1.1" fill="#fff" viewBox="3.25 6.22 93.51 87.56"> <path d="m63.375 24.363h1.1641c1.3398 0 1.3398-2.0312 0-2.0312h-1.1641c-1.3359-0.003906-1.3359 2.0312 0 2.0312zm20.164-1.0156c0 0.5625 0.45313 1.0156 1.0156 1.0156h1.1641c0.5625 0 1.0156-0.45703 1.0156-1.0156 0-0.5625-0.45703-1.0156-1.0156-1.0156h-1.1641c-0.55859-0.003906-1.0156 0.45312-1.0156 1.0156zm-10.586 0c0 0.5625 0.45312 1.0156 1.0156 1.0156h1.1641c1.3398 0 1.3398-2.0312 0-2.0312h-1.1641c-0.5625-0.003906-1.0156 0.45312-1.0156 1.0156zm16.344-17.125c4.1133 0 7.4609 3.3477 7.4609 7.4609v19.332c0 4.1133-3.3477 7.457-7.4609 7.457h-5.8633l-13.453 9.7617c-2.5898 1.875-6.1992 0.027344-6.1992-3.1602v-6.6016h-3.9805c-4.1133 0-7.4609-3.3477-7.4609-7.457l0.003906-19.336c0-4.1133 3.3438-7.4609 7.4609-7.4609zm-47.457 50.43c-3.082 0-5.5859 2.5078-5.5859 5.5859 0 3.082 2.5078 5.5859 5.5859 5.5859 3.082 0 5.5859-2.5078 5.5859-5.5859s-2.5039-5.5859-5.5859-5.5859zm-17.418 0c-3.0781 0-5.5859 2.5078-5.5859 5.5859 0 3.082 2.5078 5.5859 5.5859 5.5859 3.082 0 5.5859-2.5078 5.5859-5.5859s-2.5039-5.5859-5.5859-5.5859zm27.594 20.66c0 4.375-3.3984 7.9688-7.6953 8.2852v-5.5117c0-2.4141-1.9648-4.3789-4.3789-4.3789h-13.625c-2.4141 0-4.3789 1.9609-4.3789 4.3789v5.5117c-4.2969-0.31641-7.6953-3.9102-7.6953-8.2852v-20.316c0-4.582 3.7305-8.3125 8.3125-8.3125h21.145c4.5859 0 8.3125 3.7305 8.3125 8.3125zm-30.508-34.754c-6.4766 0-11.742 5.2656-11.742 11.742v2.8633h2.4492v-0.17578c0-5.7031 4.6406-10.344 10.344-10.344h21.145c5.7031 0 10.344 4.6406 10.344 10.344v0.17578h2.4531v-2.8594c0-6.4766-5.2695-11.742-11.746-11.742zm37.023 14.637v-2.8906c0-7.5977-6.1797-13.777-13.777-13.777h-23.246c-7.5977 0-13.777 6.1797-13.777 13.777v2.8906c-2.5156 0.25-4.4844 2.3789-4.4844 4.957v10.004c0 2.7461 2.2344 4.9844 4.9805 4.9844h3.9844v0.17578c0 5.7031 4.6406 10.344 10.344 10.344h21.145c5.7031 0 10.344-4.6406 10.344-10.344v-0.17578h2.4531v2.8633c0 6.4727-5.2695 11.742-11.746 11.742h-11.621c-1.3398 0-1.3398 2.0312 0 2.0312h11.621c7.5977 0 13.777-6.1797 13.777-13.777v-2.8906c2.5156-0.25391 4.4844-2.3789 4.4844-4.957l0.003906-10c0-2.5781-1.9688-4.707-4.4844-4.957z" fill-rule="evenodd"></path></svg>
				{/* </i> */}
				<span className="menu-title" data-i18n="">Instant Chat Agent (AI)</span>
				</a>
			</li>

			<li className={this.activeMenu('chatquestionai')+' nav-item has-sub enable'}>
				<a href="/chatquestionai">
				{/* <i className='d-flex justify-content-center align-items-center'> */}
				<svg class="mt-0" height="22px" width="22px" xmlns="http://www.w3.org/2000/svg" viewBox="64 64 512 512.04"><path d="M320 544C461.4 544 576 436.5 576 304C576 171.5 461.4 64 320 64C178.6 64 64 171.5 64 304C64 358.3 83.2 408.3 115.6 448.5L66.8 540.8C62 549.8 63.5 560.8 70.4 568.3C77.3 575.8 88.2 578.1 97.5 574.1L215.9 523.4C247.7 536.6 282.9 544 320 544zM192 272C209.7 272 224 286.3 224 304C224 321.7 209.7 336 192 336C174.3 336 160 321.7 160 304C160 286.3 174.3 272 192 272zM320 272C337.7 272 352 286.3 352 304C352 321.7 337.7 336 320 336C302.3 336 288 321.7 288 304C288 286.3 302.3 272 320 272zM416 304C416 286.3 430.3 272 448 272C465.7 272 480 286.3 480 304C480 321.7 465.7 336 448 336C430.3 336 416 321.7 416 304z"></path></svg>
				{/* </i> */}
				<span className="menu-title" data-i18n="">Default Questions (AI)</span>
				</a>
			</li>

			</ul>
		</li>

		<li className='Sidemenu-submenu SettingMenu '>
			<a href="#" onClick={this.SettingMenu.bind(this)}>
			<i className="ft-settings"></i>
			<span className="menu-title" data-i18n="">Plugin Settings</span>
			</a>
			<svg class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>
			<ul class="submenu">
					
			<li className={this.activeMenu('setting')+' nav-item has-sub enable'}>
					<a href="/setting">
					<i><svg xmlns="http://www.w3.org/2000/svg" viewBox="18.02 -46.38 604.8 604.8"><path d="M415.9 210.5c12.2-3.3 25 2.5 30.5 13.8L465 261.9c10.3 1.4 20.4 4.2 29.9 8.1l35-23.3c10.5-7 24.4-5.6 33.3 3.3l19.2 19.2c8.9 8.9 10.3 22.9 3.3 33.3l-23.3 34.9c1.9 4.7 3.6 9.6 5 14.7 1.4 5.1 2.3 10.1 3 15.2l37.7 18.6c11.3 5.6 17.1 18.4 13.8 30.5l-7 26.2c-3.3 12.1-14.6 20.3-27.2 19.5l-42-2.7c-6.3 8.1-13.6 15.6-21.9 22l2.7 41.9c.8 12.6-7.4 24-19.5 27.2l-26.2 7c-12.2 3.3-24.9-2.5-30.5-13.8l-18.6-37.6c-10.3-1.4-20.4-4.2-29.9-8.1l-35 23.3c-10.5 7-24.4 5.6-33.3-3.3l-19.2-19.2c-8.9-8.9-10.3-22.8-3.3-33.3l23.3-35c-1.9-4.7-3.6-9.6-5-14.7s-2.3-10.2-3-15.2l-37.7-18.6c-11.3-5.6-17-18.4-13.8-30.5l7-26.2c3.3-12.1 14.6-20.3 27.2-19.5l41.9 2.7c6.3-8.1 13.6-15.6 21.9-22l-2.7-41.8c-.8-12.6 7.4-24 19.5-27.2l26.2-7zM448.4 340a44 44 0 1 0 .1 88 44 44 0 1 0 -.1-88zM224.9-45.5l26.2 7c12.1 3.3 20.3 14.7 19.5 27.2l-2.7 41.8c8.3 6.4 15.6 13.8 21.9 22l42-2.7c12.5-.8 23.9 7.4 27.2 19.5l7 26.2c3.2 12.1-2.5 24.9-13.8 30.5l-37.7 18.6c-.7 5.1-1.7 10.2-3 15.2s-3.1 10-5 14.7l23.3 35c7 10.5 5.6 24.4-3.3 33.3L307.3 262c-8.9 8.9-22.8 10.3-33.3 3.3L239 242c-9.5 3.9-19.6 6.7-29.9 8.1l-18.6 37.6c-5.6 11.3-18.4 17-30.5 13.8l-26.2-7c-12.2-3.3-20.3-14.7-19.5-27.2l2.7-41.9c-8.3-6.4-15.6-13.8-21.9-22l-42 2.7c-12.5 .8-23.9-7.4-27.2-19.5l-7-26.2c-3.2-12.1 2.5-24.9 13.8-30.5l37.7-18.6c.7-5.1 1.7-10.1 3-15.2 1.4-5.1 3-10 5-14.7L55.1 46.5c-7-10.5-5.6-24.4 3.3-33.3L77.6-6c8.9-8.9 22.8-10.3 33.3-3.3l35 23.3c9.5-3.9 19.6-6.7 29.9-8.1l18.6-37.6c5.6-11.3 18.3-17 30.5-13.8zM192.4 84a44 44 0 1 0 0 88 44 44 0 1 0 0-88z"></path></svg></i>
					<span className="menu-title" data-i18n="">Settings</span>
					</a>
				</li>		
			<li className={this.activeMenu('themes')}>
            <a href="/themes">
              <i>
                <svg fill="#ffffff"  xmlns="http://www.w3.org/2000/svg" height="25px" width="25px" viewBox="63.9 64 512.1 512"><path d="M576 320C576 320.9 576 321.8 576 322.7C575.6 359.2 542.4 384 505.9 384L408 384C381.5 384 360 405.5 360 432C360 435.4 360.4 438.7 361 441.9C363.1 452.1 367.5 461.9 371.8 471.8C377.9 485.6 383.9 499.3 383.9 513.8C383.9 545.6 362.3 574.5 330.5 575.8C327 575.9 323.5 576 319.9 576C178.5 576 63.9 461.4 63.9 320C63.9 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320zM192 352C192 334.3 177.7 320 160 320C142.3 320 128 334.3 128 352C128 369.7 142.3 384 160 384C177.7 384 192 369.7 192 352zM192 256C209.7 256 224 241.7 224 224C224 206.3 209.7 192 192 192C174.3 192 160 206.3 160 224C160 241.7 174.3 256 192 256zM352 160C352 142.3 337.7 128 320 128C302.3 128 288 142.3 288 160C288 177.7 302.3 192 320 192C337.7 192 352 177.7 352 160zM448 256C465.7 256 480 241.7 480 224C480 206.3 465.7 192 448 192C430.3 192 416 206.3 416 224C416 241.7 430.3 256 448 256z"></path></svg>
              </i>
              <span className="menu-title" data-i18n="">Themes</span>
            </a>
          </li>
		    <li className={this.activeMenu('themecolor')}>
            <a href="/themecolor">
              <i>
                <svg height="25px" width="25px" xmlns="http://www.w3.org/2000/svg" viewBox="64 64 512 512"><path d="M64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320zM225.5 233.9C213.3 228.7 199.2 234.3 194 246.5C188.8 258.7 194.4 272.8 206.6 278L218.5 283.1C235.8 290.5 253.7 296 272.1 299.4L272.1 349.5C272.1 353.8 271.4 358.1 270 362.1L241.3 448.2C237.1 460.8 243.9 474.4 256.5 478.6C269.1 482.8 282.7 476 286.9 463.4L311.3 390.2C312.6 386.4 316.1 383.8 320.1 383.8C324.1 383.8 327.7 386.4 328.9 390.2L353.3 463.4C357.5 476 371.1 482.8 383.7 478.6C396.3 474.4 403 461 398.8 448.4L370.1 362.3C368.7 358.2 368 354 368 349.7L368 299.6C386.4 296.1 404.3 290.7 421.6 283.3L433.5 278.2C445.7 273 451.3 258.9 446.1 246.7C440.9 234.5 426.8 228.9 414.6 234.1L402.7 239C376.6 250.2 348.5 256 320 256C291.5 256 263.5 250.2 237.3 239L225.4 233.9zM320 224C342.1 224 360 206.1 360 184C360 161.9 342.1 144 320 144C297.9 144 280 161.9 280 184C280 206.1 297.9 224 320 224z"></path></svg>
              </i>
              <span className="menu-title" data-i18n="">Accessibility</span>
            </a>
          </li>
				
					<li className={this.activeMenu('Category')+' nav-item has-sub enable'}>
						<a href="/category">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 32 448 448"><path d="M0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm64 64l0 256 128 0 0-256-128 0zm320 0l-128 0 0 256 128 0 0-256z"></path></svg>
						</i>
						<span className="menu-title" data-i18n="">Tab Management</span>
						</a>
					</li> 

					<li className='Sidemenu-submenu MembershipMenu  has-sub'>
			<a href="#"  onClick={this.MembershipMenu.bind(this)} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="8.48 -24.63 431.64 536.63"><path d="M224.3 128L139.7-12.9c-6.5-10.8-20.1-14.7-31.3-9.1L21.8 21.3C9.9 27.2 5.1 41.6 11 53.5L80.6 192.6c-30.1 33.9-48.3 78.5-48.3 127.4 0 106 86 192 192 192s192-86 192-192c0-48.9-18.3-93.5-48.3-127.4L437.6 53.5c5.9-11.9 1.1-26.3-10.7-32.2L340.2-22.1c-11.2-5.6-24.9-1.6-31.3 9.1L224.3 128zm30.8 142.5c1.4 2.8 4 4.7 7 5.1l50.1 7.3c7.7 1.1 10.7 10.5 5.2 16l-36.3 35.4c-2.2 2.2-3.2 5.2-2.7 8.3l8.6 49.9c1.3 7.6-6.7 13.5-13.6 9.9l-44.8-23.6c-2.7-1.4-6-1.4-8.7 0l-44.8 23.6c-6.9 3.6-14.9-2.2-13.6-9.9l8.6-49.9c.5-3-.5-6.1-2.7-8.3l-36.3-35.4c-5.6-5.4-2.5-14.8 5.2-16l50.1-7.3c3-.4 5.7-2.4 7-5.1l22.4-45.4c3.4-7 13.3-7 16.8 0l22.4 45.4z"></path></svg>
			</i>
			<span className="menu-title" data-i18n="">Membership Plan</span>
			<svg onClick={this.MembershipMenu.bind(this)}  class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>

			</a>
			<ul class="submenu">
				
					<li className={this.activeMenu('MembershipCategory')+' nav-item has-sub enable'}>
						<a href="/Membershipcategory">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.05 -32.05 448 568.31"><path d="M245.9-25.9c-13.4-8.2-30.3-8.2-43.7 0-24.4 14.9-39.5 18.9-68.1 18.3-15.7-.4-30.3 8.1-37.9 21.9-13.7 25.1-24.8 36.2-49.9 49.9-13.8 7.5-22.2 22.2-21.9 37.9 .7 28.6-3.4 43.7-18.3 68.1-8.2 13.4-8.2 30.3 0 43.7 14.9 24.4 18.9 39.5 18.3 68.1-.4 15.7 8.1 30.3 21.9 37.9 22.1 12.1 33.3 22.1 45.1 41.5L42.7 458.5c-5.9 11.9-1.1 26.3 10.7 32.2l86 43c11.5 5.7 25.5 1.4 31.7-9.8l52.8-95.1 52.8 95.1c6.2 11.2 20.2 15.6 31.7 9.8l86-43c11.9-5.9 16.7-20.3 10.7-32.2l-48.6-97.2c11.7-19.4 23-29.4 45.1-41.5 13.8-7.5 22.2-22.2 21.9-37.9-.7-28.6 3.4-43.7 18.3-68.1 8.2-13.4 8.2-30.3 0-43.7-14.9-24.4-18.9-39.5-18.3-68.1 .4-15.7-8.1-30.3-21.9-37.9-25.1-13.7-36.2-24.8-49.9-49.9-7.5-13.8-22.2-22.2-37.9-21.9-28.6 .7-43.7-3.4-68.1-18.3zM224 96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Membership Category</span>
						</a>
					</li>
					<li className={this.activeMenu('Membership')+' nav-item has-sub enable'}>
						<a href="/Membership">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="8.48 -24.63 431.64 536.63"><path d="M224.3 128L139.7-12.9c-6.5-10.8-20.1-14.7-31.3-9.1L21.8 21.3C9.9 27.2 5.1 41.6 11 53.5L80.6 192.6c-30.1 33.9-48.3 78.5-48.3 127.4 0 106 86 192 192 192s192-86 192-192c0-48.9-18.3-93.5-48.3-127.4L437.6 53.5c5.9-11.9 1.1-26.3-10.7-32.2L340.2-22.1c-11.2-5.6-24.9-1.6-31.3 9.1L224.3 128zm30.8 142.5c1.4 2.8 4 4.7 7 5.1l50.1 7.3c7.7 1.1 10.7 10.5 5.2 16l-36.3 35.4c-2.2 2.2-3.2 5.2-2.7 8.3l8.6 49.9c1.3 7.6-6.7 13.5-13.6 9.9l-44.8-23.6c-2.7-1.4-6-1.4-8.7 0l-44.8 23.6c-6.9 3.6-14.9-2.2-13.6-9.9l8.6-49.9c.5-3-.5-6.1-2.7-8.3l-36.3-35.4c-5.6-5.4-2.5-14.8 5.2-16l50.1-7.3c3-.4 5.7-2.4 7-5.1l22.4-45.4c3.4-7 13.3-7 16.8 0l22.4 45.4z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Membership</span>
						</a>
					</li>

				</ul>
				</li>


				
				<li className='Sidemenu-submenu GuideMenu has-sub'>
			<a href="#"  onClick={this.GuideMenu.bind(this)} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="8 -32 632 576"><path d="M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM176 512l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-48 192 0 0 192-192 0 0-32-64 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 64-122.7 0c-45.6 0-88.5 21.6-115.6 58.2L14.3 260.9c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L112 236.7 112 512c0 17.7 14.3 32 32 32s32-14.3 32-32z"></path></svg>
			</i>
			<span className="menu-title" data-i18n="">Guide Management</span>
			<svg onClick={this.GuideMenu.bind(this)} class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>

			</a>
			<ul class="submenu">
				
			<li className={this.activeMenu('GuideCategory')}>
					<a href="/GuideCategory">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M268.9 53.2L152.3 182.8c-4.6 5.1-4.4 13 .5 17.9 30.5 30.5 80 30.5 110.5 0l31.8-31.8c4.2-4.2 9.5-6.5 14.9-6.9 6.8-.6 13.8 1.7 19 6.9L505.6 344 576 288 576 0 464 64 440.2 48.1C424.4 37.6 405.9 32 386.9 32l-70.4 0c-1.1 0-2.3 0-3.4 .1-16.9 .9-32.8 8.5-44.2 21.1zM116.6 150.7L223.4 32 183.8 32c-25.5 0-49.9 10.1-67.9 28.1L0 192 0 544 144 408 156.4 418.3c23 19.2 52 29.7 81.9 29.7l15.7 0-7-7c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l41 41 9 0c19.1 0 37.8-4.3 54.8-12.3L359 409c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l32 32 17.5-17.5c8.9-8.9 11.5-21.8 7.6-33.1l-137.9-136.8-14.9 14.9c-49.3 49.3-129.1 49.3-178.4 0-23-23-23.9-59.9-2.2-84z"/></svg>
						</i>
						<span className="menu-title" data-i18n="">Guide Category</span>
					</a>
				</li>
				<li className={this.activeMenu('GuideSubCategory')}>
					<a href="/GuideSubCategory">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 16 576.09 480"><path d="M466.8 186.5l42.5-42.5 34.7 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L223.6 16c-29 0-57.3 9.3-80.7 26.5L16.3 135.8c-17.8 13.1-21.6 38.1-8.5 55.9s38.1 21.6 55.9 8.5L183.4 112 296 112c13.3 0 24 10.7 24 24s-10.7 24-24 24l-72 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l152.2 0c33.9 0 66.5-13.5 90.5-37.5zm-357.5 139L66.7 368 32 368c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 400 280 400c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z"></path></svg>
						</i>
						<span className="menu-title" data-i18n="">Guide SubCategory</span>
					</a>
				</li>
				<li className={this.activeMenu('guide')}>
					<a href="/Guide">
						<i><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 32 608 480"><path d="M128 96c0-35.3 28.7-64 64-64l352 0c35.3 0 64 28.7 64 64l0 240-96 0 0-16c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32l0 16-129.1 0c10.9-18.8 17.1-40.7 17.1-64 0-70.7-57.3-128-128-128-5.4 0-10.8 .3-16 1l0-49zM333 448c-5.1-24.2-16.3-46.1-32.1-64L608 384c0 35.3-28.7 64-64 64l-211 0zM64 272a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zM0 480c0-53 43-96 96-96l96 0c53 0 96 43 96 96 0 17.7-14.3 32-32 32L32 512c-17.7 0-32-14.3-32-32z"></path></svg></i>
						<span className="menu-title" data-i18n="">Guide</span>
					</a>
				</li>
				</ul>
				</li>


				<li className='Sidemenu-submenu AdsMenu has-sub'>
			<a href="#"  onClick={this.AdsMenu.bind(this)} >
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="32 27.11 608 457.84"><path d="M533.6 32.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C557.5 113.8 592 180.8 592 256s-34.5 142.2-88.7 186.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C598.5 426.7 640 346.2 640 256S598.5 85.2 533.6 32.5zM473.1 107c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C475.3 170.7 496 210.9 496 256s-20.7 85.3-53.2 111.8c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5c43.2-35.2 70.9-88.9 70.9-149s-27.7-113.8-70.9-149zm-60.5 74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C393.1 227.6 400 241 400 256s-6.9 28.4-17.7 37.3c-10.3 8.4-11.8 23.5-3.5 33.8s23.5 11.8 33.8 3.5C434.1 312.9 448 286.1 448 256s-13.9-56.9-35.4-74.5zM80 352l48 0 134.1 119.2c6.4 5.7 14.6 8.8 23.1 8.8 19.2 0 34.8-15.6 34.8-34.8l0-378.4c0-19.2-15.6-34.8-34.8-34.8-8.5 0-16.7 3.1-23.1 8.8L128 160 80 160c-26.5 0-48 21.5-48 48l0 96c0 26.5 21.5 48 48 48z"></path></svg>
			</i>
			<span className="menu-title" data-i18n="">Ads Management</span>
			<svg onClick={this.AdsMenu.bind(this)} class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>

			</a>
			<ul class="submenu">
				
			<li className={this.activeMenu('advertisementcategory')}>
				<a href="/AdvertisementCategory">
				<i>
					<svg class="mt-2" height="25px" width="25px" xmlns="http://www.w3.org/2000/svg" viewBox="64 96 512 448"><path d="M64 480L64 184C64 170.7 74.7 160 88 160C101.3 160 112 170.7 112 184L112 472C112 485.3 122.7 496 136 496C149.3 496 160 485.3 160 472L160 160C160 124.7 188.7 96 224 96L512 96C547.3 96 576 124.7 576 160L576 480C576 515.3 547.3 544 512 544L128 544C92.7 544 64 515.3 64 480zM224 192L224 256C224 273.7 238.3 288 256 288L320 288C337.7 288 352 273.7 352 256L352 192C352 174.3 337.7 160 320 160L256 160C238.3 160 224 174.3 224 192zM248 432C234.7 432 224 442.7 224 456C224 469.3 234.7 480 248 480L488 480C501.3 480 512 469.3 512 456C512 442.7 501.3 432 488 432L248 432zM224 360C224 373.3 234.7 384 248 384L488 384C501.3 384 512 373.3 512 360C512 346.7 501.3 336 488 336L248 336C234.7 336 224 346.7 224 360zM424 240C410.7 240 400 250.7 400 264C400 277.3 410.7 288 424 288L488 288C501.3 288 512 277.3 512 264C512 250.7 501.3 240 488 240L424 240z"></path></svg>
				</i>
				<span className="menu-title" data-i18n="">AdvertisementCategory</span>
				</a>
				</li>

				<li className={this.activeMenu('advertisement')}>
				<a href="/Advertisement">
				<i>
					<svg class="mt-2" height="25px" width="25px" xmlns="http://www.w3.org/2000/svg" viewBox="64 128 512 384"><path d="M128 128C92.7 128 64 156.7 64 192L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 192C576 156.7 547.3 128 512 128L128 128zM480 248L480 392C480 405.3 469.3 416 456 416C448.9 416 442.5 412.9 438.1 408C427.9 413.1 416.3 416 404 416C362 416 328 382 328 340C328 298 362 264 404 264C413.9 264 423.3 265.9 432 269.3L432 248C432 234.7 442.7 224 456 224C469.3 224 480 234.7 480 248zM432 340C432 324.5 419.5 312 404 312C388.5 312 376 324.5 376 340C376 355.5 388.5 368 404 368C419.5 368 432 355.5 432 340zM224 272C215.2 272 208 279.2 208 288L208 320L256 320L256 288C256 279.2 248.8 272 240 272L224 272zM256 368L208 368L208 392C208 405.3 197.3 416 184 416C170.7 416 160 405.3 160 392L160 288C160 252.7 188.7 224 224 224L240 224C275.3 224 304 252.7 304 288L304 392C304 405.3 293.3 416 280 416C266.7 416 256 405.3 256 392L256 368z"></path></svg>
				</i>
				<span className="menu-title" data-i18n="">Advertisement</span>
				</a>
				</li>


				</ul>
				</li>


					<li className={this.activeMenu('Location')+' nav-item has-sub enable'}>
						<a href="/Location">
							<i className="ft-location" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">Location</span>
						</a>
					</li>


					<li className={this.activeMenu('promtdropdownList')+' nav-item has-sub enable'}>
						<a href="/promtdropdownList">
							<i>
								<svg height="25px" width="25px" xmlns="http://www.w3.org/2000/svg" viewBox="0 32 576 448"><path d="M512 96L160 96c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64l-48 0 0-64 48 0 0-192zM0 224c0-35.3 28.7-64 64-64l288 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 224zm64 40c0 13.3 10.7 24 24 24l240 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 240c-13.3 0-24 10.7-24 24z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Prompt Dropdown</span>
						</a>
					</li>
		
					
					<li className={this.activeMenu('DashboardManagement')+' nav-item has-sub enable'}>
						<a title="Dashboard Management Builder" href="/dashboardmanagement">
							<i className="ft-dashboard-management"></i>
							<span>Dashboard Management</span>
						</a>
					</li>
					<li className={this.activeMenu('shortcuticon')+' nav-item has-sub enable'}>
						<a title="Shortcut icon" href="/shortcuticon">
							<i className="ft-shortcut"></i>
							<span>ShortCut Icon</span>
						</a>
					</li>
					
					<li className={this.activeMenu('rolemanagement')+' nav-item has-sub enable'}>
						<a href="/rolemanagement">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 16 632.36 527.8"><path d="M320 224a104 104 0 1 0 0-208 104 104 0 1 0 0 208zM96 232a72 72 0 1 0 0-144 72 72 0 1 0 0 144zM0 416l0 32c0 17.7 14.3 32 32 32l86.7 0c-4.3-9.8-6.7-20.6-6.7-32l0-16c0-53.2 20-101.8 52.9-138.6-11.7-3.5-24.1-5.4-36.9-5.4-70.7 0-128 57.3-128 128zM616 160a72 72 0 1 0 -144 0 72 72 0 1 0 144 0zM160 432l0 16c0 17.7 14.3 32 32 32l156.8 0c-7.1-21.6-6.3-44.4 10.7-64-14-16.2-20.5-39.7-11.4-63.3 6.6-17.1 15.9-33.1 27.4-47.3 5.4-6.6 11.6-11.7 18.3-15.4-22.1-11.5-47.2-18-73.8-18-88.4 0-160 71.6-160 160zm464.6-44.1c6.3-3.6 9.5-11.1 6.8-18-4.8-12.4-11.5-24.1-19.9-34.4-4.6-5.7-12.7-6.7-19-3-21.8 12.6-48.6-2.8-48.6-28.1 0-7.3-4.9-13.8-12.1-14.9-12.9-2-26.8-2-39.7 0-7.2 1.1-12.1 7.6-12.1 14.9 0 25.2-26.8 40.7-48.6 28.1-6.3-3.6-14.4-2.6-19 3-8.4 10.3-15.1 22-19.9 34.4-2.6 6.8 .5 14.3 6.8 17.9 21.9 12.6 21.9 43.5 0 56.2-6.3 3.6-9.5 11.1-6.8 17.9 4.8 12.4 11.5 24.1 19.9 34.4 4.6 5.7 12.7 6.7 19 3 21.8-12.6 48.6 2.9 48.6 28.1 0 7.3 4.9 13.8 12.1 14.9 12.9 2 26.8 2 39.7 0 7.2-1.1 12.1-7.6 12.1-14.9 0-25.2 26.8-40.7 48.6-28.1 6.3 3.6 14.4 2.6 19-3 8.4-10.3 15.1-22 19.9-34.4 2.6-6.8-.5-14.3-6.8-17.9-21.9-12.6-21.9-43.5 0-56.2zM472 416a40 40 0 1 1 80 0 40 40 0 1 1 -80 0z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Role Management</span>
						</a>
					</li>
					<li className={this.activeMenu('userrolemanagement')+' nav-item has-sub enable'}>
						<a href="/userrolemanagement">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 16 640 464"><path d="M320 16a104 104 0 1 1 0 208 104 104 0 1 1 0-208zM96 88a72 72 0 1 1 0 144 72 72 0 1 1 0-144zM0 416c0-70.7 57.3-128 128-128 12.8 0 25.2 1.9 36.9 5.4-32.9 36.8-52.9 85.4-52.9 138.6l0 16c0 11.4 2.4 22.2 6.7 32L32 480c-17.7 0-32-14.3-32-32l0-32zm521.3 64c4.3-9.8 6.7-20.6 6.7-32l0-16c0-53.2-20-101.8-52.9-138.6 11.7-3.5 24.1-5.4 36.9-5.4 70.7 0 128 57.3 128 128l0 32c0 17.7-14.3 32-32 32l-86.7 0zM472 160a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zM160 432c0-88.4 71.6-160 160-160s160 71.6 160 160l0 16c0 17.7-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32l0-16z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">User Role</span>
						</a>
					</li>
					
				
					<li className={this.activeMenu('subscribers')+' nav-item has-sub enable'}>
						<a href="/subscribers">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="16 16 544 432"><path d="M313 87.2c9.2-7.3 15-18.6 15-31.2 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 12.6 5.9 23.9 15 31.2L194.6 194.8c-10 15.7-31.3 19.6-46.2 8.4L88.9 158.7c4.5-6.4 7.1-14.3 7.1-22.7 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 21.8 17.5 39.6 39.2 40L87.8 393.5c4.7 31.3 31.6 54.5 63.3 54.5l273.8 0c31.7 0 58.6-23.2 63.3-54.5L520.8 176c21.7-.4 39.2-18.2 39.2-40 0-22.1-17.9-40-40-40s-40 17.9-40 40c0 8.4 2.6 16.3 7.1 22.7l-59.4 44.6c-14.9 11.2-36.2 7.3-46.2-8.4L313 87.2z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Subscribers</span>
						</a>
					</li>

					{/* <li className={this.activeMenu('advertisementcategory')+' nav-item has-sub enable'}>
						<a href="/AdvertisementCategory">
							<i className="ft-add-category" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">AdvertisementCategory</span>
						</a>
					</li>

					<li className={this.activeMenu('advertisement')+' nav-item has-sub enable'}>
						<a href="/Advertisement">
							<i className="ft-add" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">Advertisement</span>
						</a>
					</li> */}
					<li className={this.activeMenu('offers')+' nav-item has-sub enable'}>
						<a href="/offers">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.07 31.92 448.08 448.08"><path d="M192 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM448 384a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM438.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-384 384c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l384-384z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Offers</span>
						</a>
					</li>

					

					<li className={this.activeMenu('InsuranceList')+' nav-item has-sub enable'}>
						<a href="/insuranceList">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="16.1 0 480 509.2"><path d="M256 0c4.6 0 9.2 1 13.4 2.9L457.8 82.8c22 9.3 38.4 31 38.3 57.2-.5 99.2-41.3 280.7-213.6 363.2-16.7 8-36.1 8-52.8 0-172.4-82.5-213.1-264-213.6-363.2-.1-26.2 16.3-47.9 38.3-57.2L242.7 2.9C246.9 1 251.4 0 256 0z"></path></svg>
						</i>
						<span className="menu-title" data-i18n="">Insurance</span>
						</a>
					</li>

					<li className={this.activeMenu('AmenitiesList')+' nav-item has-sub enable'}>
						<a href="/amenitiesList">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="32 -32.04 608 512.04"><path d="M531.2-22.4L572 32 616 32c13.3 0 24 10.7 24 24s-10.7 24-24 24l-56 0c-7.6 0-14.7-3.6-19.2-9.6l-24.1-32.1-47 99.9c-3.7 7.8-11.3 13.1-19.9 13.7s-16.9-3.4-21.7-10.6L387.2 80 344 80c-13.3 0-24-10.7-24-24s10.7-24 24-24l56 0c8 0 15.5 4 20 10.7l24.4 36.6 45.9-97.5c3.6-7.6 10.9-12.8 19.3-13.7s16.6 2.7 21.6 9.5zM320 160c0-17.7 14.3-32 32-32l9.5 0 26.6 39.9c14.4 21.6 39.3 33.8 65.2 31.9s48.8-17.6 59.8-41.1L527 129.2c45.9 7.2 81 46.9 81 94.8l0 224c0 17.7-14.3 32-32 32s-32-14.3-32-32l0-64-448 0 0 64c0 17.7-14.3 32-32 32s-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32S96 46.3 96 64l0 224 224 0 0-128zM144 192a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z"></path></svg>
						</i>
						<span className="menu-title" data-i18n="">Amenities</span>
						</a>
					</li>

					{/* <li className={this.activeMenu('GuideCategory')+' nav-item has-sub enable'}>
						<a href="/GuideCategory">
							<i className="ft-guide-category" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">Guide Category</span>
						</a>
					</li>
					<li className={this.activeMenu('GuideSubCategory')+' nav-item has-sub enable'}>
						<a href="/GuideSubCategory">
							<i className="ft-sub-category" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">Guide SubCategory</span>
						</a>
					</li>
					<li className={this.activeMenu('guide')+' nav-item has-sub enable'}>
						<a href="/Guide">
							<i className="ft-guide" aria-hidden="true"></i>
							<span className="menu-title" data-i18n="">Guide</span>
						</a>
					</li> */}
				
					{/* <li className={this.activeMenu('Guide')}>
							<a href="/Guide">
								<i className="ft-guide" aria-hidden="true"></i>
								<span className="menu-title" data-i18n="">Guide</span>
							</a>
						</li> */}
					<li className={this.activeMenu('chat')+' nav-item has-sub enable'}>
						<a href="/chat">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM165.4 321.9c20.4 28 53.4 46.1 90.6 46.1s70.2-18.1 90.6-46.1c7.8-10.7 22.8-13.1 33.5-5.3s13.1 22.8 5.3 33.5C356.3 390 309.2 416 256 416s-100.3-26-129.4-65.9c-7.8-10.7-5.4-25.7 5.3-33.5s25.7-5.4 33.5 5.3zM144 208a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Emoji Management</span>
						</a>
					</li>
					<li className={this.activeMenu('FaqCategory')+' nav-item has-sub enable'}>
						<a href="/Faqcategory">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Faq Category</span>
						</a>
					</li>

					<li className={this.activeMenu('Faq')+' nav-item has-sub enable'}>
						<a href="/Faq">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M311.4 32l8.6 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0L256 0c23.7 0 44.4 12.9 55.4 32zM248 112c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0zM192 248c16.1 0 29.2 13.1 29.2 29.2 0 8.7-3.1 13.9-6.9 17.7-4.5 4.4-10.7 7.5-16.8 9.5-14.9 5-29.5 19.3-29.5 39.5 0 13.3 10.7 24 24 24 11.5 0 21.2-8.1 23.5-19 19.2-7.1 53.7-26.3 53.7-71.8 0-42.6-34.6-77.2-77.2-77.2s-77.2 34.6-77.2 77.2c0 13.3 10.7 24 24 24s24-10.7 24-24c0-16.1 13.1-29.2 29.2-29.2zm28 168c0-15.5-12.5-28-28-28s-28 12.5-28 28 12.5 28 28 28 28-12.5 28-28z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Faq</span>
						</a>
					</li>
					<li className={this.activeMenu('raisedispute')+' nav-item has-sub enable'}>
						<a href="/RaiseDispute">
							<i>
								<svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.05 0 480.05 512"><path d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 272c0 1.5 0 3.1 .1 4.6L67.6 283c-16-15.2-41.3-14.6-56.6 1.4S-3.6 325.7 12.4 341L124.8 448c43.1 41.1 100.4 64 160 64l19.2 0c97.2 0 176-78.8 176-176l0-208c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Raise Dispute</span>
						</a>
					</li>
					<li className={this.activeMenu('abusiveword')+' nav-item has-sub enable'}>
						<a href="/abusivewords">
							<i>
								<svg class="mt-2" xmlns="http://www.w3.org/2000/svg" viewBox="32.02 64 575.98 512"><path d="M224 160C250.5 160 272 138.5 272 112C272 85.5 250.5 64 224 64C197.5 64 176 85.5 176 112C176 138.5 197.5 160 224 160zM91.4 368.5L120 320.9L120 544C120 561.7 134.3 576 152 576C169.7 576 184 561.7 184 544L184 416L200 416L200 544C200 561.7 214.3 576 232 576C249.7 576 264 561.7 264 544L264 299.3L311.4 356.4C322.7 370 342.9 371.9 356.5 360.6C370.1 349.3 372 329.1 360.7 315.5L287 226.6C268.8 204.6 241.7 191.9 213.1 191.9L177.2 191.9C143.5 191.9 112.3 209.6 94.9 238.5L36.6 335.5C27.5 350.6 32.4 370.3 47.5 379.4C62.6 388.5 82.3 383.6 91.4 368.5zM512 304C512 277.5 490.5 256 464 256C437.5 256 416 277.5 416 304C416 330.5 437.5 352 464 352C490.5 352 512 330.5 512 304zM496 408L496 466.7L454.6 425.3C447.3 418 437 414.7 426.8 416.3C416.6 417.9 407.9 424.4 403.3 433.6L355.3 529.6C347.4 545.4 353.8 564.6 369.6 572.5C385.4 580.4 404.6 574 412.5 558.2L440.6 501.9L495.3 556.6C507.7 569 524.4 575.9 541.9 575.9C578.3 575.9 607.8 546.4 607.8 510L608 408C608 377.1 582.9 352 552 352C521.1 352 496 377.1 496 408zM320 112C320 120.8 327.2 128 336 128L392 128C400.8 128 408 120.8 408 112C408 103.2 400.8 96 392 96L336 96C327.2 96 320 103.2 320 112zM319.2 161.7C311.3 157.7 301.7 161 297.7 168.9C293.7 176.8 297 186.4 304.9 190.4L352.9 214.4C360.8 218.4 370.4 215.1 374.4 207.2C378.4 199.3 375.1 189.7 367.2 185.7L319.2 161.7z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Abusive Words</span>
						</a>
					</li>
					<li className={this.activeMenu('visitreason')+' nav-item has-sub enable'}>
						<a href="/visitreason">
							<i>
								<svg class="mt-2" xmlns="http://www.w3.org/2000/svg" viewBox="64 48 511.95 528"><path d="M200 104C200 73.1 225.1 48 256 48C286.9 48 312 73.1 312 104C312 134.9 286.9 160 256 160C225.1 160 200 134.9 200 104zM181.9 261.6L194.5 324.6C155.9 337 128 373.3 128 416C128 469 171 512 224 512C259.6 512 290.7 492.6 307.3 463.8C309.6 463.9 311.9 464 314.3 464L318.4 464C319.4 464 320.5 464 321.5 464L376.7 464C356.3 528.9 295.7 576 224 576C135.6 576 64 504.4 64 416C64 342.2 114 280.1 181.9 261.6zM330.5 233.5L354.2 352L414.7 352C448 352 477.9 372.7 489.6 403.9L515.1 471.9L533.8 465.7C550.6 460.1 568.7 469.2 574.3 485.9C579.9 502.6 570.8 520.8 554.1 526.4L506.1 542.4C489.8 547.8 472.1 539.4 466 523.3L429.7 426.4C427.4 420.2 421.4 416 414.7 416L328.6 416C328.2 416 327.8 416 327.3 416L314.2 416C283.7 416 257.4 394.5 251.4 364.6L229.3 253.7C222.9 221.8 247.3 192 279.9 192C304.5 192 325.7 209.4 330.5 233.5z"></path></svg>
							</i>
							<span className="menu-title" data-i18n="">Visit Reasons</span>
						</a>
					</li>

					
					<li className={this.activeMenu('plugincontent')+' nav-item has-sub enable'}>
					<a href="/plugincontent">
						<i>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M352 64c0-17.7-14.3-32-32-32L128 32c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32zm96 128c0-17.7-14.3-32-32-32L32 160c-17.7 0-32 14.3-32 32s14.3 32 32 32l384 0c17.7 0 32-14.3 32-32zM0 448c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L32 416c-17.7 0-32 14.3-32 32zM352 320c0-17.7-14.3-32-32-32l-192 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32z"/></svg>
						</i>
						<span className="menu-title" data-i18n="">Plugin Content</span>
					</a>
				</li>


				<li className={this.activeMenu('fonts')+' nav-item has-sub enable'}>
					<a href="/fonts">
					<i className="ft-type"></i>
					<span className="menu-title" data-i18n="">Fonts</span>
					</a>
				</li>
				
				{this.state.admin_id == 1 ?<li className={this.activeMenu('templates')+' nav-item has-sub enable'}>
					<a href="/templates">
					<i className="ft-feather"></i>
					<span className="menu-title" data-i18n="">Templates</span>
					</a>
					</li>:''} 

				
				

			</ul>
		</li>

		{/* {this.state.admin_id == 1 ?<li className={this.activeMenu('companylist')}>
					<a title="Company" href="/company">
						<i className="ft-company" aria-hidden="true"></i>
						<span>Companies</span>
					</a>
		        </li>:''}   */}
     

	 
      {/* <li className={this.activeMenu('FamilyRelation')}>
        <a href="/FamilyRelation">
          <i className="ft-users"></i>
          <span className="menu-title" data-i18n="">Family Relationship</span>
        </a>
      </li> */}
      

	 
			
       

	  
       
     

	

				
		

				
       

        {/* <li className={this.activeMenu('Aifeed')}>
					<a href="/aifeed">
						<i className="ft-AI" aria-hidden="true"></i>
						<span className="menu-title" data-i18n="">Manage AI Feed</span>
					</a>
				</li> */}

       
				
		
      {/*

      <li className={this.activeMenu('Category')}>
					<a href="/category">
						<i className="ft-server" aria-hidden="true"></i>
						<span className="menu-title" data-i18n="">Category</span>
					</a>
				</li>
        <li className={this.activeMenu('ProductCategory')}>
					<a href="/ProductCategory">
						<i className="ft-server" aria-hidden="true"></i>
						<span className="menu-title" data-i18n="">Product Category</span>
					</a>
				</li>
      

     

        

       
      <li className={this.activeMenu('DoctorVisitManagement')}>
					<a href="/doctor-visite-management">
						<i className="ft-server" aria-hidden="true"></i>
						<span className="menu-title" data-i18n="">Doctor Visit Management</span>
					</a>
			</li> */}
      			


	   {/* <li className='Sidemenu-submenu  '>
        <a href="/setting" >
          <i className="ft-settings"></i>
          <span className="menu-title" data-i18n="">Settings</span>
        </a>
		<svg class="submenu-arrow" width="12" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 265.18 512" fill="#fff"><g xmlns="http://www.w3.org/2000/svg" transform="matrix(0 -1 1 0 -123.41 512)"><path d="M262.446,386.006L509.337,138.99c3.548-3.562,3.548-9.344,0-12.906c-3.453-3.453-9.438-3.453-12.859,0  L255.993,366.662L15.555,126.083c-1.719-1.703-4.031-2.672-6.453-2.672s-4.734,0.969-6.453,2.672  c-3.532,3.562-3.532,9.344,0.016,12.906l246.875,247C253.024,389.443,258.993,389.459,262.446,386.006z"></path></g></svg>
		<ul class="submenu">
			<li class="nav-item has-sub enable"><a href="/dashboard"><i class="ft-home"></i><span class="menu-title" data-i18n="">Dashboard</span></a></li>
			<li class="nav-item has-sub enable"><a title="Institutes" href="/institute"><i class="ft-users"></i><span class="menu-title" data-i18n="">Institutes</span></a></li>
			<li class="nav-item has-sub enable"><a title="Parents" href="/parents"><i class="ft-users"></i><span class="menu-title" data-i18n="">Parents</span></a></li>
			<li class="nav-item has-sub enable"><a title="Bus Helpers" href="/drivers"><i class="ft-users"></i><span class="menu-title" data-i18n="">Bus Helpers</span></a></li>
		</ul>
      </li> */}



    </ul>
    </Scrollbars>
  </div>
		</div>}
	</div>		

	
    );
  }
}

export default MenuSidebar;